export const ID = ['id'];
export const TIMESTAMP = ['timestamp'];